module.exports = {
  // "primary-color": "#2e4a3b",
  // "border-radius-base": "10px",
  // "btn-border-radius-sm": "10px",
  // "btn-border-radius-base": "10px",
  // "line-height-base": "1.5715",
  // "border-color-base": "transparent",
};
